import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';

// components
import {CardCashbackRequest} from './components';

// styles
import {
  CashbackRequestsWrapper,
  SectionCashbackRequestsWrapper,
} from './SectionCashbackRequests-styles';
import {Subtitle, TextColors} from '../../../../shared/styles';

// types
import {CashbackRequest} from '../../../../shared/services/ApiService/types';

type Props = {
  cashbackRequests: CashbackRequest[];
};

const SectionCashbackRequests = ({cashbackRequests}: Props) => {
  const {t} = useTranslation();

  // When API is ready for new cashback requests, remove this condition
  if (cashbackRequests.length === 0) {
    return null;
  }

  return (
    <SectionCashbackRequestsWrapper>
      <Subtitle color={TextColors.secondary} bold="bold">
        {t('subscription_cashbackRequests')}
      </Subtitle>
      <CashbackRequestsWrapper>
        {cashbackRequests.map((cashbackRequest, index) => (
          <CardCashbackRequest key={index} cashbackRequest={cashbackRequest} />
        ))}
        {/* When API is ready for new cashback requests, show CardRequestNewCashback */}
        {/* <CardRequestNewCashback /> */}
      </CashbackRequestsWrapper>
    </SectionCashbackRequestsWrapper>
  );
};

export default SectionCashbackRequests;
